import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {BsArrowLeftCircle, BsCalendar2Week, BsDisplayFill, BsGearFill, BsPeopleFill} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../modules/local/useTranslate";
import {Button} from "antd";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {AiFillDelete, AiOutlineClose} from "react-icons/ai";
import {useRouterSearchParam} from "../../../modules/navigation/useOnLocationChange";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {organization_department_getById_Api} from "../../../apis";
import {useOrganizationDepartmentApi} from "../../AppLocals/Organization/functions/useOrganizationDepartmentApi";
import {WorkspaceOrgDeptContainerContext} from "./WorkspaceOrgDeptContainer";
import {OrganizationDepartmentUpdateForm} from "../../AppLocals/Organization/components/OrganizationDepartmentForm";
import {useOrganizationDepartmentForm} from "../../AppLocals/Organization/functions/useOrganizationDepartmentForm";
import {DepartmentActionTypes} from "../Host/WorkspaceMembers";
import {bindingSearch} from "../../Shared/components/PagerControls";
import {WorkspaceOrganizationDepartmentMemberList} from "./WorkspaceOrganizationDepartmentMemberList";
import classNames from "classnames";
import {showDeleteConfirmDialog} from "../../AppLocals/factory/createConfirmDialog";
import {TimetableActionTypes} from "../../AppLocals/Course";
import {OrganizationTimetables} from "../../AppLocals/Deparment/components/OrganizationTimetableForm";
import useOrganizationTimetableForm from "../../AppLocals/Deparment/functions/useOrganizationTimetableForm";
import {SlateRenderer} from "../../SlateEditor";
import {convertFromString} from "../../SlateEditor/functions";
import {PiUserFocusLight} from "react-icons/pi";
import {nest} from "recompose";
import WaitingAcceptMembers from "../../MemberSetting/WaitingAcceptMembers.lazy";
import {GoverningOrganizationList} from "../Host/WorkspaceGoverningOrganizations";


const TAB_PARAM_NAME = "dept-detail-tab";

// --- Cấu trúc Menu Cấp 2 (Chi tiết Khóa học) ---
const DEPARTMENT_TABS = [
    {key: 'overview', name: 'overview', icon: <BsDisplayFill size={18}/>},
    {key: 'dept-schedules', name: 'schedules', icon: <BsCalendar2Week size={18}/>},
    {key: 'dept-members', name: 'members', icon: <BsPeopleFill size={18}/>},
    {key: 'dept-registers', name: 'registers', icon: <PiUserFocusLight size={18}/>},
    {key: 'settings', name: 'settings', icon: <BsGearFill size={18}/>},
    {key: 'destroy', name: 'delete content', icon: <AiFillDelete size={18}/>},
];


// --- Component Tab điều hướng (Dùng chung cho Cấp 2 & Cấp 3) ---
const TabNavigation = ({tabs, activeTab, onTabChange}) => {
    const t = useTranslate();

    return (
        <div
            style={{top: 'calc(3 * var(--header-height))', zIndex: 12}}
            className="mt-6 flex gap-1 overflow-x-auto background-100 rounded-t-xl border-b border-color-300 sticky">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={classNames(
                        `p-3 flex flex-center flex-shrink-0 gap-2 text-sm font-medium transition-colors border-b-2`,
                        activeTab === tab.key
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-color-200 hover:text-indigo-500 hover:border-indigo-300'
                    )}>
                    {tab.icon}
                    <span className="hidden lg:block">{t(tab.name)}</span>
                    <span className="lg:hidden">{t(tab.name)}</span>
                </button>
            ))}
        </div>
    );
}


// Component helper hiển thị Trạng thái dưới dạng badge
const StatusBadge = ({label, value, isPrimaryStatus = false}) => {
    const t = useTranslate();

    let text = value === 1 ? (isPrimaryStatus ? t("active") : t("enabled")) : (isPrimaryStatus ? t("inactive") : t("disabled"));
    let color = '';

    // Giữ màu sắc ngữ nghĩa cho Status (Xanh lá/Đỏ/Xanh dương)
    if (value === 1) {
        color = isPrimaryStatus ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700';
    } else {
        color = isPrimaryStatus ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-700';
    }

    return (
        <span className={`px-3 py-1 text-xs rounded-full ${color}`}>
            <label className="italic">
                {`${label}: `}
            </label>
            <label className="font-semibold">
                {text}
            </label>
        </span>
    );
};

// Component helper cho từng mục thông tin nhỏ
const InfoItem = ({label, value, isLink = false, to}) => {
    const t = useTranslate();

    return (
        <div className="flex flex-col gap-1">
            <label className="text-sm text-color-300 tracking-wider">
                {label}
            </label>
            {(isLink && to) ? (
                <Link to={to}
                      className="ml-2 font-semibold text-base text-indigo-600 break-words transition duration-150 ease-in-out no-underline">
                    {value}
                </Link>
            ) : (
                <p className="ml-2 text-base font-semibold text-gray-900 break-words">
                    {value}
                </p>
            )}
        </div>
    );
}

const WorkspaceOrganizationDepartmentMembersWaitingList = nest(
    ({container, children}) => (
        <WaitingAcceptMembers
            item={container}>
        </WaitingAcceptMembers>
    ),
    GoverningOrganizationList
)


const WorkspaceOrganizationDepartmentDetail = ({}) => {
    const t = useTranslate();
    const detailTab = useRouteSearchParam(TAB_PARAM_NAME) || "overview"
    const [activeTab, setActiveTab] = useState(detailTab);
    const {isSm, isLg} = useContext(LayoutContext)
    const [selectedDepartment, setSelectedDepartment] = useState({});
    const {
        current_department_id, setCurrentDepartmentId,
        onSelectWorkspaceOrgDeptContainerRoute
    } = useContext(WorkspaceOrgDeptContainerContext);

    const {handleAsyncAction: getDepartmentById} = useAsyncAction({
        apiInfo: organization_department_getById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setSelectedDepartment(dataItem);
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const {
        onCreate, creatingAsync,
        onUpdate, updatingAsync,
        onDelete, deletingAsync,
        addMember, addingMemberAsync,
        editMember, editingMemberAsync,
        removeMember, removingMemberAsync,
        setMemberActive, settingMemberActiveAsync
    } = useOrganizationDepartmentApi({})

    const {
        modal,
        action,
        handleAction,
        refreshToken,
        onCancel
    } = useOrganizationDepartmentForm({
        organizationDepartment: selectedDepartment,
        organization: selectedDepartment?.organization
    })

    const {
        modal: organizationTimetableModal,
        onCancel: onOrganizationTimetableCancel,
        handleAction: handleOrganizationTimetableAction,
        refreshKey: refreshOrganizationTimetableKey
    } = useOrganizationTimetableForm({organizationDepartment: selectedDepartment, organization: selectedDepartment?.organization})

    useEffect(() => {
        if (current_department_id) {
            getDepartmentById({}, {id: current_department_id})
        }
    }, [current_department_id])

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderDepartmentContent = useMemo(() => {
            switch (activeTab) {
                case 'overview':
                    return (
                        <div className="flex flex-col gap-6">
                            <h1 className="mb-2 flex flex-col">
                                <Link to={getLinkToDetail(selectedDepartment)}
                                      className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide no-underline">
                                    {selectedDepartment.title}
                                </Link>
                                {selectedDepartment.department_group_title && (
                                    <span className="font-medium text-lg text-indigo-600">
                                        {selectedDepartment?.department_group_title}
                                    </span>
                                )}
                            </h1>
                            {selectedDepartment?.description && (
                                <div className="text-sm text-color-300 tracking-wider">
                                    {selectedDepartment?.description}
                                </div>
                            )}
                            <div className="flex flex-col">
                                <h2 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">
                                    {t("details")}
                                </h2>
                                <div
                                    className={classNames(
                                        `leading-relaxed whitespace-pre-wrap p-2 border-l-3 border-color-200 rounded-lg`,
                                        selectedDepartment?.about ?
                                            'shadow-items text-gray-800' :
                                            'background-100 text-color-400 italic tracking-wide'
                                    )}>
                                    {selectedDepartment?.about ?
                                        <SlateRenderer value={convertFromString(selectedDepartment?.about)}/> :
                                        t('detail department description')
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <h2 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">
                                    {t("organizational structure")}
                                </h2>
                                <div className="flex flex-col gap-4">
                                    {/* Thông tin Tổ chức Mẹ (Organization) */}
                                    <InfoItem
                                        label={t("owner")}
                                        value={selectedDepartment.organization?.title || 'unknown'}
                                        isLink={!!selectedDepartment.organization?.id}
                                        to={getLinkToDetail(selectedDepartment.organization)}
                                    />

                                    {/* Thông tin Nhóm/Hội đoàn Mẹ (Department) - Có thể có hoặc không */}
                                    {(selectedDepartment.parent && selectedDepartment.parent.title) && (
                                        <InfoItem
                                            label={t("parent group")}
                                            value={selectedDepartment.parent?.title || 'unknown'}
                                            isLink={!!selectedDepartment.parent?.id}
                                        />
                                    )}

                                    {/* Nút hành động cho Desktop */}
                                    <div
                                        className="mt-2 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <button
                                            className="block px-4 py-2 bg-indigo-600 text-white font-medium rounded-lg shadow-md hover:bg-indigo-700 transition"
                                            onClick={() => setActiveTab('dept-members')}>
                                            {t("members")}
                                        </button>
                                        {selectedDepartment.edit && (
                                            <button
                                                className="block px-4 py-2 bg-red-600 text-white font-medium rounded-lg shadow-md hover:bg-red-700 transition"
                                                onClick={() => setActiveTab('settings')}>
                                                {t("edit information")}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                case 'dept-schedules':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-1 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("schedules")}
                            </h3>
                            <div className="flex flex-col gap-3">
                                <span className="text-color-300 tracking-wider">
                                    {t('manage details and active period')}
                                </span>
                                <div className="flex justify-end">
                                    <Button
                                        color="primary" variant="solid"
                                        className="flex flex-center no-border font-semibold"
                                        onClick={() => {
                                            handleOrganizationTimetableAction(TimetableActionTypes.TIMETABLE_CREATE,
                                                {
                                                    organization_department_id: selectedDepartment?.id,
                                                    organization_id: selectedDepartment?.organization?.id,
                                                }
                                            )
                                        }}>
                                        {t('add schedule')}
                                    </Button>
                                </div>
                            </div>
                            {!!selectedDepartment?.id && bindingSearch({
                                onCancel: onOrganizationTimetableCancel,
                                item: selectedDepartment,
                            })(OrganizationTimetables)}
                        </div>
                    );
                case 'dept-members':
                    return (
                        <div>
                            <div className="flex flex-col">
                                <h3 className="mb-1 font-bold text-base text-gray-700 tracking-wide uppercase flex-1">
                                    {`${t("members")}`}
                                </h3>
                                <div className="flex flex-col gap-3">
                                    <span className="text-color-300 tracking-wider">
                                        {t('workspace member title description')}
                                    </span>
                                    <div className="flex justify-end gap-3">
                                        <Button
                                            color="primary" variant="filled"
                                            className="flex items-center rounded-lg shadow-md"
                                            onClick={() => {
                                                handleAction(DepartmentActionTypes.DEPT_ADD_ORG_MEMBER)
                                            }}>
                                            {t('add member')}
                                        </Button>
                                        <Button
                                            color="primary" variant="solid"
                                            className="flex items-center rounded-lg shadow-md"
                                            onClick={() => {
                                                handleAction(DepartmentActionTypes.DEPT_ADD_MEMBER)
                                            }}>
                                            {t('create new')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-6 flex flex-col gap-4">
                                {!!selectedDepartment?.id && bindingSearch({
                                    onCancel,
                                    item: selectedDepartment,
                                    refreshToken
                                })(WorkspaceOrganizationDepartmentMemberList)}
                            </div>
                        </div>
                    );
                case 'dept-registers':
                    return (
                        <div className="flex flex-col gap-4">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("registers")}
                            </h3>
                            {
                                !!selectedDepartment?.id &&
                                <WorkspaceOrganizationDepartmentMembersWaitingList container={selectedDepartment}/>
                            }
                        </div>
                    );
                case 'settings':
                    return (
                        <div className="flex flex-col space-y-6">
                            <div className="flex flex-col gap-1">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t("settings")}
                                </h3>
                                <p className="text-color-300 tracking-wider">
                                    {t("manage details and active period")}
                                </p>
                            </div>
                            {!!selectedDepartment?.id && (
                                <OrganizationDepartmentUpdateForm
                                    initialValues={selectedDepartment}
                                    onCancel={onCancel}
                                    onSubmit={(values) => {
                                        onUpdate(values, {id: selectedDepartment?.id})
                                    }}
                                />
                            )}
                        </div>
                    );
                case 'destroy':
                    return (
                        <div className="flex flex-col space-y-6">


                            <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                                <h3 className="text-xl font-semibold text-red-700 mb-3">{t("delete department")}</h3>
                                <p className="mb-4 text-color-300 tracking-wider">
                                    {t("this action will permanently delete the department and all related data")}
                                </p>
                                <div className="flex justify-end">
                                    <button
                                        onClick={() => {
                                            showDeleteConfirmDialog({
                                                translate: t,
                                                title: 'delete this',
                                                message: 'are you sure you want to delete this',
                                                onOk: () => {
                                                    onDelete({}, {id: selectedDepartment?.id})
                                                },
                                            })
                                        }}
                                        className="bg-red-600 text-white px-6 py-2 rounded-xl font-medium shadow-md hover:bg-red-700 transition-colors text-sm flex items-center">
                                        <AiOutlineClose className="w-4 h-4 mr-2"/>
                                        {t("delete permanently")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                default:
                    return null;
            }
        },
        [refreshToken, refreshOrganizationTimetableKey, activeTab, current_department_id, selectedDepartment?.id]);

    return (
        <div className="min-h-screen w-full">
            <div className="mb-6 p-4 background shadow-lg rounded-b-xl stickyTop1 z-12">
                <button
                    onClick={() => {
                        onSelectWorkspaceOrgDeptContainerRoute({current_department_id: ''})
                    }}
                    className="mb-2 flex items-center font-medium text-color-300 hover:text-color-100 cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {t("back to groups list")}
                </button>
                <Link to={getLinkToDetail(selectedDepartment)} className="text-gray-800 no-underline">
                    <h1 className="font-bold text-2xl tracking-wide">
                        {selectedDepartment.title}
                    </h1>
                </Link>
            </div>

            <TabNavigation tabs={DEPARTMENT_TABS} activeTab={activeTab} onTabChange={(value) => {
                onChangeSearchParams({[TAB_PARAM_NAME]: value})
                setActiveTab(value)
            }}/>

            <div className="p-6 background rounded-b-xl shadow-lg">
                {renderDepartmentContent}
            </div>

            {modal}
            {organizationTimetableModal}
        </div>
    );
};


export default WorkspaceOrganizationDepartmentDetail
